import * as Yup from "yup";
import { LABELS, NAMES } from "./Config";

let {
    TITLE,
    SUB_CATEGORY,
    DESCRIPTION,
    UPLOAD_AUDIO,
    UPLOAD_THUMBNAIL,
    SESSION_SUCCESS_MESSAGE,
    RADIO_GROUP,
    SESSIONS,
    SESSION_TITLE,
    SESSION_DESCRIPTION,
    AUTHOR,
    NARRATOR,
    SESSION_UPLOAD_AUDIO,
    SESSION_COMPLETION_MESSAGE,
    UPLOAD_IMAGE
} = LABELS;

export const initialValues = {
    AudioForm: {
        [NAMES[TITLE]]: "",
        [NAMES[SUB_CATEGORY]]: null,
        [NAMES[AUTHOR]]: null,
        [NAMES[NARRATOR]]: null,
        [NAMES[DESCRIPTION]]: "",
        [NAMES[UPLOAD_AUDIO]]: null,
        [NAMES[UPLOAD_IMAGE]]: null,
        [NAMES[UPLOAD_THUMBNAIL]]: null,

        [NAMES[SESSION_SUCCESS_MESSAGE]]: "",
        [NAMES[RADIO_GROUP]]: ""
    },
    AudioSeriesForm: {
        [NAMES[TITLE]]: "",
        [NAMES[SUB_CATEGORY]]: null,
        [NAMES[AUTHOR]]: null,
        [NAMES[NARRATOR]]: null,
        [NAMES[DESCRIPTION]]: "",
        [NAMES[UPLOAD_THUMBNAIL]]: null,
        [NAMES[UPLOAD_IMAGE]]: null,

        [NAMES[SESSIONS]]: [
            {
                [NAMES[SESSION_TITLE]]: "",
                [NAMES[SESSION_DESCRIPTION]]: "",
                [NAMES[SESSION_COMPLETION_MESSAGE]]: "",
                [NAMES[RADIO_GROUP]]: "",
                [NAMES[SESSION_UPLOAD_AUDIO]]: ""
            }
        ]
    }
};

export const AUDIO_FORM_VALIDATION_SCHEMA = Yup.object({
    [NAMES[TITLE]]: Yup.string()
        .max(55, "Title cannot exceed 55 characters")
        .required("Please enter the title"),

    [NAMES[SUB_CATEGORY]]: Yup.array()
        .min(1, "Please select at least one Sub Category")
        .required("Please select the Sub Category"),

    [NAMES[AUTHOR]]: Yup.object().required("Please select the author's name"),

    [NAMES[NARRATOR]]: Yup.object().required("Please select the narrator's name"),

    [NAMES[DESCRIPTION]]: Yup.string()
        .max(255, "Description cannot exceed 255 characters")
        .required("Please enter a description"),

    [NAMES[UPLOAD_AUDIO]]: Yup.mixed().required("Audio file is required"),
    [NAMES[UPLOAD_THUMBNAIL]]: Yup.mixed().required("Thumbnail is required"),
    [NAMES[UPLOAD_IMAGE]]: Yup.mixed().required("Image is required"),
    [NAMES[SESSION_SUCCESS_MESSAGE]]: Yup.string()
        .max(100, "Session success message cannot exceed 100 characters")
        .required("Please enter the session success message"),
    [NAMES[RADIO_GROUP]]: Yup.string().required("Please select an option for audio content")
});

export const ONBOARDING_AUDIO_FORM_VALIDATION_SCHEMA = Yup.object({
    [NAMES[TITLE]]: Yup.string()
        .max(55, "Title cannot exceed 55 characters")
        .required("Please enter the title"),

    [NAMES[AUTHOR]]: Yup.object().required("Please select the author's name"),

    [NAMES[NARRATOR]]: Yup.object().required("Please select the narrator's name"),

    [NAMES[DESCRIPTION]]: Yup.string()
        .max(255, "Description cannot exceed 255 characters")
        .required("Please enter a description"),

    [NAMES[UPLOAD_AUDIO]]: Yup.mixed().required("Audio file is required"),
    [NAMES[UPLOAD_THUMBNAIL]]: Yup.mixed().required("Thumbnail is required"),
    [NAMES[UPLOAD_IMAGE]]: Yup.mixed().required("Image is required"),
    [NAMES[SESSION_SUCCESS_MESSAGE]]: Yup.string()
        .max(100, "Session success message cannot exceed 100 characters")
        .required("Please enter the session success message")
});

export const SOUNDSCAPE_AUDIO_FORM_VALIDATION_SCHEMA = Yup.object({
    [NAMES[TITLE]]: Yup.string()
        .max(55, "Title cannot exceed 55 characters")
        .required("Please enter the title"),

    // [NAMES[SUB_CATEGORY]]: Yup.object().required("Please select a sub-category"),
    [NAMES[SUB_CATEGORY]]: Yup.array()
        .min(1, "Please select at least one Sub Category")
        .required("Please select the Sub Category"),

    [NAMES[AUTHOR]]: Yup.object().required("Please select the author's name"),

    [NAMES[DESCRIPTION]]: Yup.string()
        .max(255, "Description cannot exceed 255 characters")
        .required("Please enter a description"),

    [NAMES[UPLOAD_AUDIO]]: Yup.mixed().required("Audio file is required"),
    [NAMES[UPLOAD_THUMBNAIL]]: Yup.mixed().required("Thumbnail is required"),
    [NAMES[UPLOAD_IMAGE]]: Yup.mixed().required("Image is required"),
    [NAMES[SESSION_SUCCESS_MESSAGE]]: Yup.string()
        .max(100, "Session success message cannot exceed 100 characters")
        .required("Please enter the session success message"),
    [NAMES[RADIO_GROUP]]: Yup.string().required("Please select an option for audio content")
});

export const AUDIO_SERIES_FORM_VALIDATION_SCHEMA = Yup.object({
    [NAMES[TITLE]]: Yup.string()
        .max(55, "Title cannot exceed 55 characters")
        .required("Please enter the title"),

    // [NAMES[SUB_CATEGORY]]: Yup.object().required("Please enter the Name"),
    [NAMES[SUB_CATEGORY]]: Yup.array()
        .min(1, "Please select at least one Sub Category")
        .required("Please select the Sub Category"),

    [NAMES[AUTHOR]]: Yup.object().required("Please enter the Name"),
    [NAMES[NARRATOR]]: Yup.object().required("Please enter the Name"),
    [NAMES[DESCRIPTION]]: Yup.string()
        .max(255, "Description cannot exceed 255 characters")
        .required("Please enter a description"),
    [NAMES[UPLOAD_THUMBNAIL]]: Yup.mixed().required("Thumbnail is required"),
    [NAMES[UPLOAD_IMAGE]]: Yup.mixed().required("Image is required"),
    [NAMES[SESSIONS]]: Yup.array()
        .of(
            Yup.object().shape({
                [NAMES[SESSION_TITLE]]: Yup.string()
                    .max(55, "Session Title cannot exceed 55 characters")
                    .required("Session Title is required"),
                [NAMES[SESSION_DESCRIPTION]]: Yup.string()
                    .max(255, "Session Description cannot exceed 255 characters")
                    .required("Session Description is required"),
                [NAMES[SESSION_COMPLETION_MESSAGE]]: Yup.string()
                    .max(100, "Session success message cannot exceed 100 characters")
                    .required("Session Success Message is required"),
                [NAMES[SESSION_UPLOAD_AUDIO]]: Yup.object()
                    .nullable()
                    .required("Audio file is required"),
                [NAMES[RADIO_GROUP]]: Yup.string().required("Session Subscription is required")
            })
        )
        .min(1, "At least one session is required")
});
